(function () {
    'use strict';

    angular.module("imApp").factory("customerDiscGrpProdService", ['$ihttp', function ($ihttp) {
        let service = {
            listCustomerDiscounts: function (parms) {
                return $ihttp.post({
                    method: 304,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
